module.exports = __webpack_public_path__ + "img/2025-02-13b_2.0f58f22a.jpg";